module.exports = __webpack_public_path__ + "img/json.d5cfc49c.svg";